const getDefaultState = () => {
  return {
    shoppingMallType: 'CAFE24',
    useCommerce: false,
    useCafe24: false,
    isUseAboutTalk: false,
    aboutTalkHeader: {},
    useSmartStore: false,
    isAvailableRequestProdImg: false,
    prodImgList: {},
    useMakeshop: false
  }
}
const state = getDefaultState()

const getters = {
  shoppingMallType: (state) => {
    return state.shoppingMallType
  },
  useCommerce: (state) => {
    return state.useCommerce
  },
  useCafe24: (state) => {
    return state.useCafe24
  },
  isUseAboutTalk (state) {
    return state.isUseAboutTalk
  },
  aboutTalkHeader (state) {
    return state.aboutTalkHeader
  },
  useSmartStore: (state) => {
    return state.useSmartStore
  },
  isAvailableRequestProdImg: (state) => {
    return state.isAvailableRequestProdImg
  },
  prodImgList: (state) => {
    return state.prodImgList
  },
  useMakeshop: (state) => {
    return state.useMakeshop
  }
}

const actions = {}

const mutations = {
  setShoppingMallType (state, shoppingMallType) {
    state.shoppingMallType = shoppingMallType
  },
  setUseCommerce (state, useCommerce) {
    state.useCommerce = useCommerce
  },
  setUseCafe24 (state, useCafe24) {
    state.useCafe24 = useCafe24
  },
  setIsUseAboutTalk (state, data) {
    state.isUseAboutTalk = data.isUse
    if (data.isUse) {
      state.aboutTalkHeader = {
        'dmc-client-id': data.dmcClientId,
        'dmc-client-secret': data.dmcClientSecret,
        'Content-Type': 'application/json'
      }
    }
  },
  setUseSmartStore (state, useSmartStore) {
    state.useSmartStore = useSmartStore
  },
  setIsAvailableRequestProdImg (state, isAvailableRequestProdImg) {
    state.isAvailableRequestProdImg = isAvailableRequestProdImg
  },
  setProdImgList: (state, prodImgList) => {
    state.prodImgList = prodImgList
  },
  setUseMakeshop (state, useMakeshop) {
    state.useMakeshop = useMakeshop
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/talkOperation/index.js